import {useCallback, useEffect, useState} from 'react';
import {Close} from '@material-ui/icons';
import Cookies from 'js-cookie';
import {Language} from '../../../context/LanguageContext';
import {Switch} from '@material-ui/core';
import {styled} from '@mui/material';
import {useUser} from '../../../hooks';

export default function FormProgramKerja({onClose, data, type}) {
  const {language, newObj} = Language();
  const {createProgramKerja, updateProgramKerja} = useUser();
  const tokens_session = Cookies.get('token');
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    kod_activiti: '',
    jenis_kerja: '',
    status: false,
    status_projek: '',
    getah: false,
    sawit: false,
  });
  const MaterialUISwitch = styled(Switch)(({checked}) => ({
    '& .MuiSwitch-thumb': {
      color: checked ? '#68aaff !important' : 'dimgray',
    },
    '& .Mui-checked': {
      color: checked ? '#5a7ba6 !important' : 'dimgray',
    },
    '& .MuiSwitch-track': {
      backgroundColor: checked ? '#5a7ba6 !important' : 'dimgray',
    },
  }));
  const handleChangeInput = (e) => {
    const {name, value} = e.target;
    setPayload((prev) => ({...prev, [name]: value}));
  };
  const handleChangeChecked = (e) => {
    const {name, checked} = e.target;
    setPayload((prev) => ({...prev, [name]: checked}));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      switch (type) {
        case 'add':
          await createProgramKerja(tokens_session, {...payload});
          break;
        case 'edit':
          await updateProgramKerja(tokens_session, {
            ...payload,
            id: data.selected.seq,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };
  const handleChangeStatusProject = (value) => {
    setPayload((prev) => {
      const status_project = prev.status_projek
        ? prev.status_projek.split(',')
        : [];
      if (status_project.includes(value)) {
        const newStatusProject = status_project.filter(
          (item) => item !== value
        );
        return {...prev, status_projek: newStatusProject.join(',')};
      } else {
        return {
          ...prev,
          status_projek: (status_project.length > 0
            ? [...status_project, value]
            : [value]
          ).join(','),
        };
      }
    });
  };

  const jenisTanamanValue = (str) => {
    switch (str) {
      case 'Getah':
        return {
          getah: true,
          sawit: false,
        };
      case 'Sawit':
        return {
          getah: false,
          sawit: true,
        };
      case 'Sawit/Getah':
        return {
          getah: true,
          sawit: true,
        };
      default:
        return;
    }
  };
  useEffect(() => {
    if (type === 'edit') {
      setPayload({
        kod_activiti: data.selected.kodActiviti,
        jenis_kerja: data.selected.jenisKerja,
        status: data.selected.status,
        status_projek: data.selected.statusProjek,
        ...jenisTanamanValue(data.selected.jenisTanaman),
      });
    }
  }, []);

  return (
    <div className='modal_content center add_program_kerja'>
      <div className='modal_header'>
        <p className='modal_title'>{newObj.ProgramKerjaWord[language]}</p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className='modal_body'>
        <form
          method='POST'
          className='add_program_kerja_form'
          onSubmit={handleSubmit}
        >
          <div className='add_program_kerja_form_wrapper'>
            <div className='wrapper_box'>
              <div className='add_program_kerja_input col'>
                <label htmlFor='program_kerja'>
                  {newObj.ActivityCodeWord[language]}
                </label>
                <input
                  type='number'
                  name='kod_activiti'
                  value={payload.kod_activiti}
                  onChange={handleChangeInput}
                />
              </div>
              <div className='add_program_kerja_input col'>
                <label htmlFor='description'>
                  {newObj.WorkTypeWord[language]}
                </label>
                <input
                  type='text'
                  name='jenis_kerja'
                  onChange={handleChangeInput}
                  value={payload.jenis_kerja}
                />
              </div>

              <div
                className='add_program_kerja_check row'
                style={{
                  marginTop: '20px',
                }}
              >
                <label htmlFor='status'>{newObj.StatusWord[language]}</label>
                <MaterialUISwitch
                  id='status'
                  checked={payload.status}
                  onChange={handleChangeChecked}
                  name='status'
                />
              </div>
            </div>
            <div className='wrapper_box'>
              <div
                className='add_program_kerja_input col'
                style={{
                  borderBottom: '1px solid #e0e0e0',
                }}
              >
                <p>{newObj.StatusProjectWord[language]}</p>
                <div className='add_program_kerja_check row'>
                  <label htmlFor='status_projek_pembangunan'>Pembangunan</label>
                  <MaterialUISwitch
                    checked={payload.status_projek
                      .split(',')
                      .includes('Pembangunan')}
                    onClick={() => handleChangeStatusProject('Pembangunan')}
                    name='status_projek'
                    value={'Pembangunan'}
                  />
                </div>
                <div className='add_program_kerja_check row'>
                  <label htmlFor='status_prahasil'>Prahasil</label>
                  <MaterialUISwitch
                    // id='status_prahasil'
                    checked={payload.status_projek
                      .split(',')
                      .includes('Pra Hasil')}
                    onClick={() => handleChangeStatusProject('Pra Hasil')}
                    name='status_projek'
                    value={'Pra Hasil'}
                  />
                </div>
                <div className='add_program_kerja_check row'>
                  <label htmlFor='status_berhasil'>Berhasil</label>
                  <MaterialUISwitch
                    checked={payload.status_projek
                      .split(',')
                      .includes('Berhasil')}
                    onClick={() => handleChangeStatusProject('Berhasil')}
                    name='status_projek'
                    value={'Berhasil'}
                  />
                </div>
              </div>

              <div className='add_program_kerja_input col'>
                <p>Jenis Tanaman</p>
                <div className='add_program_kerja_check row'>
                  <label htmlFor='jenis_tanaman_sawit'>
                    {newObj.SawitWord[language]}
                  </label>
                  <MaterialUISwitch
                    id='jenis_tanaman_sawit'
                    checked={payload.sawit}
                    onClick={() =>
                      setPayload((prev) => ({...prev, sawit: !prev.sawit}))
                    }
                    name='sawit'
                    value={payload.sawit}
                  />
                </div>
                <div className='add_program_kerja_check row'>
                  <label htmlFor='jenis_tanaman_getah'>
                    {newObj.GetahWord[language]}
                  </label>
                  <MaterialUISwitch
                    id='jenis_tanaman_getah'
                    checked={payload.getah}
                    onClick={(e) => {
                      setPayload((prev) => ({...prev, getah: !prev.getah}));
                    }}
                    name='getah'
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='modal_flexible_btn_ctr'>
            <button loading={loading}>
              {type === 'add'
                ? newObj.AddWord[language]
                : newObj.EditWord[language]}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
